export class ListEksClustersResponse {
    'eksClusters';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "eksClusters",
            "baseName": "eksClusters",
            "type": "Array<EksCluster>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListEksClustersResponse.attributeTypeMap;
    }
    constructor() {
    }
}
